import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView } from '../utils/leadCapture';
import { pageView } from '../lib/tracking';

export function useAttributionPageView(): void {
  const { pathname } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    recordPageView();
    pageView();
  }, [pathname]);
}
